





























import { Component, Vue, Provide } from "vue-property-decorator";
import { arrayOrNull } from "@/utils";
import { UserWorkStatus } from "@/pbjs/xcommon/enum_pb";

const Pending = () => import("./views/pending/index.vue");
const PartiallyCompleted = () => import("./views/partiallyCompleted/index.vue");
const Completed = () => import("./views/completed/index.vue");

@Component({
  name: "auditOrderHandle",
  components: { Pending, PartiallyCompleted, Completed },
})
export default class auditOrderHandle extends Vue {
  @Provide() private activeName: string = "first";
  @Provide() private issearchUserDone: boolean = false;
  @Provide() private workStatus: any = "";
  @Provide() private ordertakeStatus: number = 0;

  private handleClick(tab: any, event: any) {
    // 点击tab,缓存
    localStorage.setItem("tabInspect", tab.name);
  }
  private created() {
    // 刷新页面获取缓存或者默认值
    this.activeName = localStorage.getItem("tabInspect") || "first";
    this.dwSearchUserRequest();
  }
  private destroyed() {
    // 页面销毁时,将缓存修改为默认值，以便第一次进入时查看默认选中tab
    localStorage.setItem("tabInspect", "first");
  }
  // 处理搜索用户的参数
  private dwGetUserListFuc() {
    let _arg: any = {
      Page: {
        pageIndex: 1,
        pageSize: 20,
      },
      inputName: null,
      inputEmail: null,
      roleValue: null,
      userStatus: null,
      userId: Number(localStorage.getItem("userid")),
      twoFactAuthRange: null,
      outSourceRange: null,
      attendancetimefrom: null,
      attendancetimeto: null,
    };
    return _arg;
  }
  //  搜索用户列表
  private async dwSearchUserRequest() {
    let _arg: any = this.dwGetUserListFuc();
    const { setGetUserListReq, getUserListRequest }: any = await import(
      "@/request/getUserList"
    );
    let res = await getUserListRequest.handleHttp(setGetUserListReq(_arg), null);
    if (res && res.right) {
      this.workStatus = res.userinfosList[0] && res.userinfosList[0].workstatus;
    } else {
      this.$message.error(res.commonout.errmsg);
    }
  }
  private async changeUserStatus() {
    let _arg: any = {
      status: this.workStatus == 1 ? 2 : 1,
      userId: [Number(localStorage.getItem("userid"))],
    };
    const {
      getUpdateUserWorkStatusReq,
      getUpdateUserWorkStatusRequest,
    }: any = await import("@/request/inspectOrderManage");
    let res = await getUpdateUserWorkStatusRequest.handleHttp(
      getUpdateUserWorkStatusReq(_arg),
      this
    );
    this.issearchUserDone = res ? res.loading : false;
    if (res && res.right) {
      this.workStatus = this.workStatus == 1 ? 2 : 1;
      this.$message({
        type: "success",
        message: "success",
      });
    }
  }
}
